import React, { useState } from 'react';
import { Alert } from 'antd';
import Spin from 'src/components/common/Spin';
import { ColumnSorting } from './QaErrorsDetailsTable/QaErrorsDetailsTable.config';
import QaErrorsDetailsTable from './QaErrorsDetailsTable/QaErrorsDetailsTable';
import useQaErrorsDetailsListFetch from '../hooks/useQaErrorsDetailsListFetch';
import { QaError } from '../types/QaErrors';
import { Filters } from '../QaErrorsProvider';
import styles from './QaErrorsDetailsList.module.less';

const PAGE_NUMBER = 1;
const PAGE_SIZE = 10;

const QaErrorsDetailsList: React.FC<{ qaError: QaError; filters: Filters }> = ({
  qaError,
  filters,
}): React.ReactElement => {
  const [page, setPage] = useState(PAGE_NUMBER);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [sorting, setSorting] = useState<ColumnSorting>({ field: 'errorCode', order: 'ascend' });
  const { applicationId: appId, siteCode, scriptName } = qaError;
  const [{ data, loading, error, total }] = useQaErrorsDetailsListFetch({
    sorting,
    page,
    pageSize,
    appId,
    siteCode,
    scriptName,
    errorCode: filters.errorCode,
  });

  const firstLoading = loading && data === null;

  return (
    <>
      {error && (
        <Alert message="Error" description="Something went wrong. Please try again later..." type="error" showIcon />
      )}
      {firstLoading ? (
        <div className={styles.listLoader}>
          <Spin spinning={firstLoading} />
        </div>
      ) : (
        <QaErrorsDetailsTable
          items={data || []}
          sorting={sorting}
          loading={loading}
          page={page}
          pageSize={pageSize}
          total={total}
          onSortingChange={setSorting}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
        />
      )}
    </>
  );
};

export default QaErrorsDetailsList;
